import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M17.95 14.943H2.5v2.246h15.45v2.246a.57.57 0 0 0 .31.52.47.47 0 0 0 .552-.115l3.042-3.37a.62.62 0 0 0 0-.797l-3.042-3.37a.47.47 0 0 0-.548-.118.56.56 0 0 0-.314.512zM6.05 9.046H21.5V6.8H6.05V4.554a.56.56 0 0 0-.314-.512.47.47 0 0 0-.548.119L2.146 7.53a.62.62 0 0 0 0 .797l3.042 3.37a.47.47 0 0 0 .552.115.57.57 0 0 0 .31-.52z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }